import {LineProcessor} from './line-processor';
import {JsonToSong} from './json-to-song';
import {ChordInlineBindingService} from './chord-inline-binding';
import {SongsEmptySectionsRemover} from './songs-empty-sections-remover';

export function presentationSelection(content, state) {
  const parser = new JsonToSong();
  const songs = new ChordInlineBindingService().convertSongs(
    parser.songsEnriched(new LineProcessor().parseChordsTxt(content, true)));
  const song = songs.find(item => item.currentPosition === Number(state.songNumber));
  if (!song) throw new Error('Nie znaleziono pieśni do prezentacji.');
  const visible = song.sections.filter(section => SongsEmptySectionsRemover.isVisibleSection(section, state.chordsVisible ?? true));
  const requested = song.sections[state.sectionIndex ?? 0];
  const section = visible.includes(requested) ? requested : visible[0];
  const line = state.kind === 'song' ? (song.lineStart ?? song.lines?.[0]?.lineNumber ?? 1)
    : section?.content.flat().find(item => Number.isSafeInteger(item.lineNumber))?.lineNumber;
  if (!line) throw new Error('Nie znaleziono sekcji do prezentacji.');
  return {...state, line, canonicalSectionIndex: state.kind === 'song' ? undefined : visible.indexOf(section) + 1};
}
